import { render, staticRenderFns } from "./ProductLogistic.vue?vue&type=template&id=382bab15&scoped=true&lang=pug&"
import script from "./ProductLogistic.vue?vue&type=script&lang=ts&"
export * from "./ProductLogistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bab15",
  null
  
)

export default component.exports